/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { TFunction } from 'i18next';
import { Box } from '@mantine/core';

import { CreditOptionsResponse } from 'types';
import { AppUtils } from 'utils';

import CreditRequestEmploymentItem from './item';

interface CreditRequestEmploymentProps {
  disabled?: boolean;
  form: any;
  options: CreditOptionsResponse;
  partnerEmploymentForm: any;
  t: TFunction;
  userEmploymentForm: any;
  tempEmploymentObject: object;
  partner: boolean;
}

const CreditRequestEmployment = ({
  disabled,
  form,
  options,
  partnerEmploymentForm,
  t,
  userEmploymentForm,
  tempEmploymentObject,
  partner
}: CreditRequestEmploymentProps) => {

  useEffect(() => {
    if (form.values.partnerIncludeInApplication && partnerEmploymentForm.getTransformedValues().length === 0) {
      AppUtils.addNewObject(partnerEmploymentForm, { ...tempEmploymentObject, creditRequestId: form.values.id, partner: true });
    }
  }, [form.values.partnerIncludeInApplication])

  const employmentForm = partner ? partnerEmploymentForm : userEmploymentForm;

  return (
    <Box>
      {Object.keys(employmentForm.getTransformedValues()).map((el: any, index: number) =>
        <CreditRequestEmploymentItem
          key={el}
          disabled={disabled}
          form={form}
          options={options}
          index={index}
          t={t}
          userEmploymentForm={employmentForm}
          partner={partner}
          tempEmploymentObject={tempEmploymentObject}
        />
      )}
    </Box>
  )
}

export default CreditRequestEmployment;